export enum TabAlignType {
  Horizontal = `horizontal`,
  Vertical = `vertical`,
}
